import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { postNamedCommand, postNamedQuery } from '../service'

const DOMAIN = 'dagger'

export const LISTENER_KEYS = {
  all: ['listeners'],
  list: (filters) => ['listeners', filters]
}

export const useListListeners = (filters = {}) =>
  useQuery({
    queryKey: LISTENER_KEYS.list(filters),
    queryFn: async () => {
      const { data } = await postNamedQuery(DOMAIN, 'list-listeners', filters)
      return data
    },
    staleTime: 15_000
  })

export const useCreateListener = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await postNamedCommand(DOMAIN, 'create-listener', body)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: LISTENER_KEYS.all }).catch(console.error)
    }
  })
}

export const useUpdateListener = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await postNamedCommand(DOMAIN, 'update-listener', body)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: LISTENER_KEYS.all }).catch(console.error)
    }
  })
}

export const useDeleteListener = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await postNamedCommand(DOMAIN, 'delete-listener', body)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: LISTENER_KEYS.all }).catch(console.error)
    }
  })
}

export const usePurgeStaleListeners = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body = {}) => {
      const { data } = await postNamedCommand(DOMAIN, 'purge-stale-listeners', body)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: LISTENER_KEYS.all }).catch(console.error)
    }
  })
}
